import { writable } from "svelte/store";
import { PIL } from "./constants";
export const pairListSelectedCategories = writable([]);
export const pairs = writable([]);
export const pairCount = writable(0);
export const pairsLoadDone = writable(false);
export const rounds = writable([]);
export const metaNfts = writable([]);
export const bids = writable([]);
export const coreContract = writable();
export const viewCoreContract = writable();
export const viewWeb3 = writable();
export const currentChainId = writable(1); // TODO
export const tokenPrice = writable({
    PIL: 0.1,
    USDC: 1,
    WETH: 1000,
});
export const multipliers = writable({
    PIL: 1,
    USDC: 1,
    WETH: 1,
});
export const tokenAddress = writable({
    PIL: '',
    USDC: '',
    WETH: '',
});
export const nftAcceptable = writable({});
export const metaNftAcceptable = writable({});
export const uploadDone = writable(false);
export const pairDetail = writable({
    id: 0,
    nftAddress: '',
    tokenId: 0,
    title: '',
    denominator: PIL,
    roundTokenPrice: 0,
    category: '',
    collection: '',
    imageUrl: '',
    apy: 0,
    roundPriceChange: 0,
    nftPrice: 0,
    nftPriceChange: 0,
    yearPairRewardPerRound: 0,
});
export const storedIsWalletConnected = localStorage.getItem("isWalletConnected");
export const isWalletConnected = writable(storedIsWalletConnected);
isWalletConnected.subscribe(value => {
    localStorage.setItem("isWalletConnected", value);
});
export const pairListCurrentOffset = writable(0);
export const pairListIsEndReached = writable(false);
export const pairListSelectedOrder = writable(0);
